/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MerchantDealUsageDTO
 */
export interface MerchantDealUsageDTO {
  /**
   *
   * @type {number}
   * @memberof MerchantDealUsageDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof MerchantDealUsageDTO
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof MerchantDealUsageDTO
   */
  usageByDeals: number;
}

/**
 * Check if a given object implements the MerchantDealUsageDTO interface.
 */
export function instanceOfMerchantDealUsageDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "usageByDeals" in value;

  return isInstance;
}

export function MerchantDealUsageDTOFromJSON(json: any): MerchantDealUsageDTO {
  return MerchantDealUsageDTOFromJSONTyped(json, false);
}

export function MerchantDealUsageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantDealUsageDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    usageByDeals: json["usageByDeals"]
  };
}

export function MerchantDealUsageDTOToJSON(value?: MerchantDealUsageDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    usageByDeals: value.usageByDeals
  };
}
